class GiftQuantity extends QuantityInput {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.giftWrapping = document.querySelector('gift-wrapping');
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));

    // Check if gift wrap exists in the cart and the size of the cart
    if (this.giftWrapsInCart > 0 && this.cartItemsSize === 0) {
      this.giftWrapping.removeGiftWrap();
    }
  }

  update() {
    this.input.value = 1; // Set to 1 as we charge per cart
    this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define('gift-quantity', GiftQuantity);

class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.miniCart = document.querySelector('mini-cart');
    this.giftWrapId = this.dataset.giftWrapId;
    this.giftWrapping = this.dataset.giftWrapping;
    this.cartItemsSize = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapsInCart = parseInt(this.getAttribute('gift-wraps-in-cart'));

    // Add event listener for the checkbox
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", (event) => {
      if (event.target.checked) {
        this.setGiftWrap();
      } else {
        this.removeGiftWrap();
      }
    });

    if (this.miniCart) return;

    // If there are gift wraps in the cart but no items, remove the gift wrap
    if (this.giftWrapsInCart === 0 && this.cartItemsSize > 0) {
      this.removeGiftWrap();
    }
  }

  setGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 1 // Set gift wrap quantity to 1 for the cart
      },
      attributes: {
        'gift-wrapping': true
      },
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
      .then(response => response.json())
      .then(response => {
        loadingOverlay.classList.add('hidden');
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch(e => {
        console.error(e);
      });
  }

  removeGiftWrap() {
    const loadingOverlay = this.querySelector('.loading-overlay');
    loadingOverlay.classList.remove('hidden');

    const body = JSON.stringify({
      updates: {
        [this.giftWrapId]: 0 // Remove gift wrap
      },
      attributes: {
        'gift-wrapping': '',
        'gift-note': ''
      },
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body })
      .then(response => response.json())
      .then(response => {
        loadingOverlay.classList.add('hidden');
        this.miniCart && this.miniCart.renderContents(response);
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      { id: 'mini-cart', section: 'mini-cart', selector: '.shopify-section' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'mobile-cart-icon-bubble', section: 'mobile-cart-icon-bubble', selector: '.shopify-section' },
      { id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' }
    ];
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
      fetch(`${theme.routes.cart_update_url}`, { ...fetchConfig(), body });
    }, 300));
  }
}
customElements.define('gift-note', GiftNote);
